import { AxiosError } from 'axios';
import {
  MutationFunction,
  useMutation,
  UseMutationResult,
  useQueryClient
} from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';

type DeleteTagAssignmentVariables = {
  session_id: string;
  document_id: string;
  assignment_id: string;
};

export const useDeleteTagAssignment = (): UseMutationResult<
  void,
  AxiosError<BaseError>,
  DeleteTagAssignmentVariables
> => {
  const queryClient = useQueryClient();

  const deleteTagAssignment: MutationFunction<
    void,
    DeleteTagAssignmentVariables
  > = ({ session_id, document_id, assignment_id }) =>
    Axios.delete(
      DELETE_URL(session_id, document_id, assignment_id).deleteTagAssignment
    ).then(() => {});

  return useMutation<void, AxiosError<BaseError>, DeleteTagAssignmentVariables>(
    deleteTagAssignment,
    {
      onSuccess: (_data, vars) => {
        queryClient.invalidateQueries([
          'tagAssignments',
          vars.session_id,
          vars.document_id
        ]);
      },
      useErrorBoundary: false
    }
  );
};
